/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TPublishOfferModel,
  IPublishOfferRequest,
  IMappers,
  IPublishOfferSuccessResponse,
  IPublishOfferFailResponse,
  TPublishOfferResponse,
} from './types';

const defaultConfig: TPublishOfferModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: `/addform/v3/offers/`,
  hostType: 'ud-api',
} as TPublishOfferModel;

function createPublishOfferModel(parameters: IPublishOfferRequest): TPublishOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublishOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IPublishOfferRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchPublishOffer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IPublishOfferOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TPublishOfferResponse> {
  const { response, statusCode } = await httpApi.fetch(createPublishOfferModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublishOfferSuccessResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IPublishOfferFailResponse);
    }
  }

  return { response, statusCode } as TPublishOfferResponse;
}

export { defaultConfig, createPublishOfferModel, fetchPublishOffer };
